import { render, staticRenderFns } from "./ManageEventForm.vue?vue&type=template&id=8dc2407a&scoped=true"
import script from "./ManageEventForm.vue?vue&type=script&lang=js"
export * from "./ManageEventForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc2407a",
  null
  
)

export default component.exports